import { UPDATE_WS, UPDATE_WS_SUCCESSFUL, UPDATE_WS_FAILED } from './actionTypes';

export const updateWorkstation = (ws, history) => {
    return {
        type: UPDATE_WS,
        payload: { ws, history }
    }
}

export const updateWorkstationSuccessful = (msg) => {
    return {
        type: UPDATE_WS_SUCCESSFUL,
        payload: msg
    }
}

export const updateWorkstationFailed = (msg) => {
    return {
        type: UPDATE_WS_FAILED,
        payload: msg
    }
}
